"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerStyles = void 0;
exports.default = SmartTestimonialsCard;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _attributionBlock = _interopRequireDefault(require("@site/pattern-library-core/attribution-block"));
var _renderRating = require("./render-rating");
var _settings = require("@site/pattern-library-core/settings");
var _text = _interopRequireDefault(require("@ux/text"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ContainerStyles = exports.ContainerStyles = `
  display: flex;
  flex-direction: column;
  min-height: 28.125rem;
  border-radius: ${_intents.default.ux.box.borderRadius};
  padding: var(--fixed-space-200);
  height: 100%;

  @media ${_patternLibraryUtils.device.laptopLg} {
    padding: var(--fixed-space-400);
  }
`;
const CardWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardWrapper",
  class: "pl-c1kh9wir"
});
const Rating = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Rating",
  class: "pl-r19zknh7"
});
const Quote = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "Quote",
  class: "pl-q3e3hkd",
  vars: {
    "q3e3hkd-0": [({
      size
    }) => size === 'large' ? 'var(--fixed-space-200)' : 'var(--fixed-space-100)'],
    "q3e3hkd-2": [({
      size
    }) => size === 'large' ? '1.875rem' : '1.25rem']
  }
});

/**
 * Render Trustpilot Card
 *
 * @param {Object} props React props for Trustpilot Card
 * @param {string} props.title Card title
 * @param {string} props.quote Review text
 * @param {number} props.rating Rating
 * @param {string} props.altTextForReviewStars {0} replacable string for aria-label
 * @param {string} props.quoteFontSize Option to change review text font size
 * @param {string} props.attribution Attribution text
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} Trustpilot Card
 * @public
 */
function SmartTestimonialsCard({
  invert = false,
  partial,
  title,
  quote,
  rating,
  altTextForReviewStars = 'Rating {0} of out 5 stars.',
  attribution,
  attributionHeadline,
  attributionDescription
}) {
  const [quoteFontSize, setQuoteFontSize] = (0, _react.useState)('large');
  const MAX_CHR = 460;
  (0, _react.useEffect)(() => {
    if (quote?.length >= 190) setQuoteFontSize('small');
  }, []);
  return /*#__PURE__*/_react.default.createElement(CardWrapper, {
    "data-cy": "trustpilot-card",
    "data-partial": partial || (invert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -1,
    className: "text-uppercase",
    text: title
  }), /*#__PURE__*/_react.default.createElement(Rating, {
    role: "img",
    "aria-label": altTextForReviewStars.replace('{0}', rating)
  }, (0, _renderRating.renderRating)(rating, 18, altTextForReviewStars)), /*#__PURE__*/_react.default.createElement(Quote, {
    size: quoteFontSize
  }, `${quote.substring(0, MAX_CHR)}`)), (attribution || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    attribution: attribution || attributionHeadline,
    isBasic: true,
    onlyBoldLineOne: true
  }), attributionDescription && /*#__PURE__*/_react.default.createElement(_attributionBlock.default, {
    isBasic: true,
    attributionPosition: "bottom-left",
    tabletAttributionPosition: "bottom-left",
    attribution: attributionDescription
  })));
}
SmartTestimonialsCard.propTypes = {
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  title: _propTypes.default.string,
  quote: _propTypes.default.string,
  // eslint-disable-next-line max-len
  rating: _propTypes.default.oneOf(_settings.TrustPilotRatings),
  altTextForReviewStars: _propTypes.default.string.isRequired,
  quoteFontSize: _propTypes.default.oneOf(['small', 'large']),
  attribution: _propTypes.default.string,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string
};